import type { WidgetInitOptions } from "./widget//types/widgetTypes";
import { createRootContainer } from "./widget/createRootContainer";

declare global {
  interface Window {
    ChatWidget?: {
      init: (options: WidgetInitOptions) => void;
      destroy: () => void;
    };
    ChatWidgetSettings?: Partial<WidgetInitOptions>;
  }
}

let destroyFn: null | (() => void) = null;

function init(options: WidgetInitOptions) {
  // Merge settings depuis window.VehicleChatWidgetSettings si présent
  const merged: WidgetInitOptions = {
    ...options,
    ...(window.ChatWidgetSettings ?? {}),
  };

  // idempotent
  if (destroyFn) destroyFn();

  const { destroy } = createRootContainer(merged);
  destroyFn = destroy;
}

function destroy() {
  if (destroyFn) destroyFn();
  destroyFn = null;
}

// On expose un seul namespace global
window.ChatWidget = { init, destroy };
